/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiImportOrganisationConfigResponse
 */
export interface InternalApiImportOrganisationConfigResponse {
    /**
     * 
     * @type {number}
     * @memberof InternalApiImportOrganisationConfigResponse
     */
    organisationId: number;
}

/**
 * Check if a given object implements the InternalApiImportOrganisationConfigResponse interface.
 */
export function instanceOfInternalApiImportOrganisationConfigResponse(value: object): value is InternalApiImportOrganisationConfigResponse {
    if (!('organisationId' in value) || value['organisationId'] === undefined) return false;
    return true;
}

export function InternalApiImportOrganisationConfigResponseFromJSON(json: any): InternalApiImportOrganisationConfigResponse {
    return InternalApiImportOrganisationConfigResponseFromJSONTyped(json, false);
}

export function InternalApiImportOrganisationConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiImportOrganisationConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'organisationId': json['organisationId'],
    };
}

export function InternalApiImportOrganisationConfigResponseToJSON(json: any): InternalApiImportOrganisationConfigResponse {
    return InternalApiImportOrganisationConfigResponseToJSONTyped(json, false);
}

export function InternalApiImportOrganisationConfigResponseToJSONTyped(value?: InternalApiImportOrganisationConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organisationId': value['organisationId'],
    };
}

